import React, { useState, useEffect } from "react";
import { useDispatch, shallowEqual, useSelector } from "react-redux";
import { useParams, useHistory, Link } from "react-router-dom";
import * as actions from "./_redux/Actions";
import { useSubheader } from "../../../_metronic/layout";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
// import { Multiselect } from "multiselect-react-dropdown";
import {
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar,
  DatePickerField,
  TimePickerField,
  Select,
  Input,
} from "../../../_metronic/_partials/controls";
import DeleteDialog from "../../components/DeleteDialog";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";
import { Col, Row, Accordion, Button } from "react-bootstrap";
import TournamentSummeryDetails from "./TournamentSummeryDetails";
import moment from "moment";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import helperFunc from "../../../_metronic/_helpers/helperFunc";
import * as UIHelpers from "../../components/UIHelpers";
import {imageUrl} from "../../components/UIHelpers";
// import {
//   CONTEST_STATUS_BTN,
//   // CONTEST_STATUS_BG,
//   CONTEST_STATUS_BORDER,
//   CONTEST_STATUS,
// } from "../../components/UIHelpers";

const TournamentView = (props) => {
  const { id } = useParams();
  let history = useHistory();
  const suhbeader = useSubheader();
  const dispatch = useDispatch();
  const [isContainerVisible, setIsContainerVisible] = useState(false);
  const [isDeleteShow, setIsDeleteShow] = useState(false);
  const [deleteItemRow, setDeleteItemRow] = useState(undefined);
  const onClickAddRound = () => {
    setIsContainerVisible(!isContainerVisible);
  };

  const [rounds, setRounds] = useState([
    {
      tournamentId: id,
      title: "",
      matchCount: "",
      subMatchCount: 0,
      hasSubMatch: "false",
      playerCount: "",
      roundMap: "",
      isFinalRound: "false",
      roundPrespective: "",
      contestMatches: [],
    },
  ]);
  // const [canclebox, setCanclebox] = useState(false);
  // const [reloadcount, setReloadcount] = useState(0);

  const [frmInitialValues, setFrmInitialValues] = useState({
    roomId: "",
    roomPassword: "",
    steamLink: "",
    numberOfPlayedUsers: 0,
    isActive: true,
  });

  const { currentState } = useSelector(
    (state) => ({ currentState: state.tournamentsSlice }),
    shallowEqual
  );
  const {
    actionsLoading,
    contestUsers,
    listLoading,
    tournamentForEdit,
    bracketsImages,
  } = currentState;

  useEffect(() => {
    if (Object.keys(bracketsImages).length !== 0) {
      console.log(bracketsImages, "data is avaiable");
      let body = {
        tournamentId: id,
        bracketsImage: bracketsImages,
      };
      dispatch(actions.saveBracketsImage(body)).then((sucess) =>
        sucess ? dispatch(actions.fetchSingle(id)) : null
      );
    }
  }, [bracketsImages]);

  useEffect(() => {
    dispatch(actions.fetchSingle(id));
    //dispatch(actions.fetchContestUsersList(id));
  }, [id, dispatch]);

  const saveContest = (values) => {
    if (!id) {
      dispatch(actions.createItem(values)).then((sucess) =>
        sucess ? backToList() : null
      );
    } else {
      dispatch(actions.updateItem(values)).then((sucess) =>
        sucess ? backToList() : null
      );
    }
  };

  const saveSteamUrl = (values) => {
    var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;

    if (
      !values.steamLink ||
      (values.steamLink && !regex.test(values.steamLink))
    ) {
      NotificationManager.error("Please Add Valid Steaming URL", "Error");
    }
  };

  const backToList = () => {
    history.push(`/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/list`);
  };

  const CurrencyIcoon = ({ item }) => {
    return (
      <span className="text-dark-50 font-weight-bold">
        {item.currency && item.currency.img ? (
          <img
            className="currency"
            // src={`${process.env.REACT_APP_UPLOADED_FILE_URL}/${item.currency &&
            //   item.currency.img.default}`}
            src={imageUrl(item.currency && item.currency.img.default)}
            alt="currency"
          />
        ) : (
          <span className="text-dark-50 font-weight-bold">₹</span>
        )}
      </span>
    );
  };

  // const staticData1 = "Example rules for the tournament.";

  useEffect(() => {
    // setTitle(_title);
    suhbeader.setTitle("Tournament Info");
  }, [id]);

  // const staticData = {
  //   date: "2023-01-01",
  //   time: "10:00 AM",
  //   matchId: "12345",
  // };

  const onCheckSubMatches = (e, index) => {
    if (e.target.value === "false") {
      rounds[index].hasSubMatch = "true";
    } else {
      rounds[index].hasSubMatch = "false";
    }
    setRounds([...rounds]);
  };
  const onChangeRound = (value, index, name, type) => {
    // let d = Date.now();
    // let t= moment(d).format('hh:mm a');
    // let D= moment(d).format('YYYY-MM-DD')
    if (type == "matches") {
      rounds[index].matchCount = value;
      rounds[index].hasSubMatch = "false";
      rounds[index].subMatchCount = 0;
      rounds[index].contestMatches = [];
      for (let i = 0; i < Number(value); i++) {
        rounds[index].contestMatches.push({
          matchTitle: `R${tournamentForEdit.tournamentRoundsAry.length +
            1}M${i + 1}`,
          date: new Date(),
          time: new Date(),
          userCount: "",
          winnerCount: "",
          subMatchDetails: [],
        });
      }
    } else if (type == "subMatches") {
      let matches = rounds[index].contestMatches;
      rounds[index].subMatchCount = value;
      for (let i = 0; i < matches.length; i++) {
        matches[i].subMatchDetails = [];
        for (let j = 0; j < Number(value); j++) {
          matches[i].subMatchDetails.push({
            matchTitle: `${matches[i].matchTitle} - ${j + 1}`,
            date: new Date(),
            time: new Date(),
            map: "",
            prespective: "",
          });
        }
      }
    } else {
      rounds[index][name] = value;
    }
    console.log(rounds);
    setRounds([...rounds]);
  };
  const onChangeMatch = (value, mainIndex, matchIndex, name) => {
    console.log(value);
    rounds[mainIndex].contestMatches[matchIndex][name] = value;
    console.log(rounds);
    setRounds([...rounds]);
  };
  const onChangeSubMatch = (
    value,
    mainIndex,
    matchIndex,
    subMatchIndex,
    name
  ) => {
    rounds[mainIndex].contestMatches[matchIndex].subMatchDetails[subMatchIndex][
      name
    ] = value;
    console.log(rounds);
    setRounds([...rounds]);
  };
  const saveRounds = () => {
    const totalSum = rounds[0].contestMatches
      .map((item) => parseInt(item.userCount))
      .reduce((prev, next) => prev + next);
    if (rounds[0].playerCount < totalSum) {
      NotificationManager.error(
        "Total players count should not be more then total user's count.",
        "Error"
      );
    } else {
      if (
        rounds[0]?.hasSubMatch === true ||
        (rounds[0]?.hasSubMatch === "true" && rounds[0]?.subMatchCount === 0) ||
        rounds[0]?.subMatchCount === "0"
      ) {
        NotificationManager.error("Please add sub match.", "Error");
      } else {
        dispatch(actions.createTournamentsRound(rounds[0])).then((success) => {
          if (success) {
            NotificationManager.success(
              "success",
              "Tournament round has been created successfully!"
            );
            setIsContainerVisible(!isContainerVisible);
            setRounds([
              {
                tournamentId: id,
                title: "",
                matchCount: "",
                subMatchCount: 0,
                hasSubMatch: "false",
                playerCount: "",
                roundMap: "",
                roundPrespective: "",
                contestMatches: [],
              },
            ]);
            dispatch(actions.fetchSingle(id));
          }
        });
      }
    }
  };
  const uploadImage = (e) => {
    console.log(e.target.files);
    if (e.target.files && e.target.files[0]) {
      let img = e.target.files[0];
      console.log("img: ", img);
      let payload = {
        img: img,
        name: "img",
      };
      dispatch(actions.uploadBracketsImage(payload));
    }
  };
  const viewContest = (id) => {
    const url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/contest/${id}`;
    window.open(url, "_blank");
    // history.push(`/tournaments/contest/${id}`);
  };
  const viewRankSummary = () => {
    const url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/rank-summary/${id}`;
    window.open(url, "_blank");
    // history.push(`/tournaments/contest/${id}`);
  };
  const viewPointSummary = () => {
    const url = `/${process.env.REACT_APP_PUBLIC_URL_SFIX}tournaments/point-summary/${id}`;
    window.open(url, "_blank");
    // history.push(`/tournaments/contest/${id}`);
  };
  const renderHeader = (subMatch) => {
    return (
      <thead>
        <tr>
          <th>Title</th>
          <th>Date</th>
          <th>Time</th>
          <th>RP TIME </th>
          <th>SS TIME </th>
          <th>Status</th>
          {!subMatch && <th>Total User Count</th>}
          {!subMatch && <th>Total Winners Count</th>}
          <th>Map</th>
          <th>Perspective</th>
          <th>Action</th>
        </tr>
      </thead>
    );
  };
  const hideDeleteConfirm = () => {
    setIsDeleteShow(false);
    setDeleteItemRow(undefined);
  };
  const deleteMatchRound = (round) => {
    setIsDeleteShow(true);
    setDeleteItemRow(round);
  };
  const deleteItem = () => {
    dispatch(
      actions.deleteMatchRound({
        _id: deleteItemRow._id,
        tournamentId: deleteItemRow.tournamentId,
      })
    ).then((success) => {
      if (success) {
        dispatch(actions.fetchSingle(id));
        hideDeleteConfirm();
      } else {
        hideDeleteConfirm();
      }
    });
  };
  const roundSchema = Yup.object().shape({
    title: Yup.string().required("Title is required!"),
    matchCount: Yup.number()
      .required("Match count is required!")
      .min(1, "Zero is not allowed"),
    hasSubMatch: Yup.boolean(),
    playerCount: Yup.number()
      .required("Total user count is required!")
      .min(1, "Zero is not allowed"),
    // subMatchCount: Yup.number().when("hasSubMatch", { is: true, then: Yup.number().required("Sub match count is required!") }).min(1, "Zero is not allowed"),
    roundMap: Yup.string().when("hasSubMatch", {
      is: false,
      then: Yup.string().required("Map is required!"),
    }),
    roundPrespective: Yup.string().when("hasSubMatch", {
      is: false,
      then: Yup.string().required("Prespective is required!"),
    }),
    contestMatches: Yup.array().of(
      Yup.object().shape({
        //matchTitle: Yup.string().required('Title is required!'),
        userCount: Yup.number()
          .required("User count is required!")
          .min(1, "Zero is not allowed"),
        // date: Yup.date().required('Date is required!'),
        // time: Yup.date().required('Time is required!'),
        date: Yup.date().when("hasSubMatch", {
          is: false,
          then: Yup.date().required("Date is required!"),
        }),
        time: Yup.date().when("hasSubMatch", {
          is: false,
          then: Yup.date().required("Time is required!"),
        }),
        winnerCount: Yup.number()
          .required("winner count is required!")
          .lessThan(
            Yup.ref("userCount"),
            "Winner count should not be more than and equal to user count"
          )
          .min(1, "Zero is not allowed"),
        subMatchDetails: Yup.array().of(
          Yup.object().shape({
            //matchTitle: Yup.string().required('Title is required!'),
            date: Yup.string().required("Date is required!"),
            time: Yup.string().required("Time is required!"),
            map: Yup.string().required("Map is required!"),
            prespective: Yup.string().required("Prespective is required!"),
          })
        ),
      })
    ),
  });

  const onClickItem = (e, name) => {
    var link = document.createElement("a");
    link.href = e;
    link.download = true;
    document.body.appendChild(link);
    link.click();
  };

  return (
    <>
      <NotificationContainer />
      <DeleteDialog
        show={isDeleteShow}
        name={deleteItemRow && deleteItemRow.title}
        item={deleteItemRow}
        onDelete={deleteItem}
        onHide={hideDeleteConfirm}
      />
      <Row>
        <div className="col-md-12">
          <TournamentSummeryDetails type={"view"} />
        </div>
      </Row>

      <Formik
        enableReinitialize={true}
        initialValues={frmInitialValues}
        onSubmit={(values) => {
          saveContest(values);
        }}
      >
        {({ values }) => (
          <Form className="form form-label-right w-100">
            <Row>
              {actionsLoading && <ModalProgressBar />}
              <div className="col-md-12">
                {tournamentForEdit.bracketsImage === undefined ||
                tournamentForEdit.bracketsImage === "undefined" ||
                tournamentForEdit.bracketsImage === null ||
                tournamentForEdit.bracketsImage === "null" ? (
                  <Col lg={24} md={24} sm={24} xs={24} className="mb-4">
                    <Card>
                      <CardHeader title={"Upload Bracket Image"}></CardHeader>
                      <CardBody>
                        <>
                          <Formik>
                            <Form>
                              <div
                                className="image-input image-input-empty image-input-outline"
                                id="kt_image_5"
                                style={{
                                  backgroundImage: `url(https://icons-for-free.com/iconfiles/png/512/box+document+outline+share+top+upload+icon-1320195323221671611.png)`,
                                }}
                              >
                                <div className="image-input-wrapper"></div>
                                <label
                                  className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                  data-action="change"
                                  title="Change Image"
                                >
                                  <i className="fa fa-pen icon-sm text-muted"></i>
                                  <input
                                    type="file"
                                    name="image-upload"
                                    onChange={(e) => uploadImage(e)}
                                    accept=".png, .jpg, .jpeg"
                                  />
                                </label>
                                <span
                                  className="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow"
                                  data-action="remove"
                                  title="Remove Image"
                                >
                                  <i className="ki ki-bold-close icon-xs text-muted"></i>
                                </span>
                              </div>
                            </Form>
                          </Formik>
                        </>
                      </CardBody>
                    </Card>
                  </Col>
                ) : (
                  <Col lg={24} md={24} sm={24} xs={24} className="mb-4">
                    <Card>
                      <CardHeader title={"Upload Bracket Image"}></CardHeader>
                      <CardBody>
                        <Carousel>
                          <div
                            onClick={() =>
                              onClickItem(
                                `${UIHelpers.imageUrl}${tournamentForEdit?.bracketsImage?.default}`
                              )
                            }
                          >
                            <img
                              src={`${UIHelpers.imageUrl}${tournamentForEdit?.bracketsImage?.default}`}
                              width={25}
                              onClick={() =>
                                onClickItem(
                                  `${UIHelpers.imageUrl}${tournamentForEdit?.bracketsImage?.default}`
                                )
                              }
                            />
                          </div>
                        </Carousel>
                      </CardBody>
                    </Card>
                  </Col>
                )}
              </div>
            </Row>
          </Form>
        )}
      </Formik>

      <Row>
      {helperFunc.isButtonAccess('tournament.openTournaments.add') && (
        <div className="col-md-12 mb-10 pl-5">
            {(tournamentForEdit &&
              tournamentForEdit?.tournamentRoundsAry &&
              tournamentForEdit?.tournamentRoundsAry.length > 0) ? (
                tournamentForEdit?.tournamentRoundsAry.findIndex((a) => a.isFinalRound) === -1 && (
                  <button
                    type="button"
                    onClick={onClickAddRound}
                    className="btn btn-primary"
                  >
                    Add Round
                  </button>
                )) : (
              <button type="button" onClick={onClickAddRound} className="btn btn-primary">
                Add Round
              </button>
            )
          }


          {
            tournamentForEdit.isFinalCompleted === true ?
              tournamentForEdit.winningTerm === "perRank" ?
                <button type="button" onClick={() => viewRankSummary()} className="btn ml-10 btn-primary">Rank Sumamry</button>
                : <button type="button" onClick={() => viewPointSummary()} className="btn ml-10 btn-primary">Point Sumamry</button>
              : null
          }
        </div>)}
        {isContainerVisible && (
          <div className="col-md-12 w-100">
            <Formik
              initialValues={rounds[0]}
              validationSchema={roundSchema}
              onSubmit={(values) => {
                saveRounds();
              }}
            >
              {({
                values,
                touched,
                errors,
                handleBlur,
                handleSubmit,
                handleChange,
                isValid,
                dirty,
              }) => (
                <Form
                  className="form form-label-right w-100"
                  onSubmit={handleSubmit}
                >
                  <div
                    className="pb-5"
                    data-wizard-type="step-content"
                    data-wizard-state="current"
                  >
                    <h4 className="mb-10 font-weight-bold text-dark">
                      Setup Your Rounds
                    </h4>
                    <div className="row"></div>
                    <div className="col-md-12 p-0">
                      <FieldArray
                        name="contestMatches"
                        render={(arrayHelpers) =>
                          rounds.map((round, index) => {
                            return (
                              <Card className="gx-card clearfix">
                                <CardHeader
                                  title={`Round ${tournamentForEdit
                                    .tournamentRoundsAry.length + 1}`}
                                ></CardHeader>
                                <CardBody>
                                  <Row>
                                    <Col lg={2} md={12} sm={24} xs={24}>
                                      {/* <input name={`title-${index}`} onBlur={handleBlur} type="text" */}
                                      <Field
                                        name={`title-${index}`}
                                        onBlur={handleBlur}
                                        component={Input}
                                        placeholder="Name"
                                        value={round.title}
                                        onChange={(e) => {
                                          onChangeRound(
                                            e.target.value,
                                            index,
                                            "title"
                                          );
                                        }}
                                      />
                                      {touched?.[`title-${index}`] &&
                                        errors.title && (
                                          <div style={{ color: "red" }}>
                                            {errors.title}
                                          </div>
                                        )}
                                    </Col>
                                    <Col lg={2} md={12} sm={24} xs={24}>
                                      <Field
                                        name={`matchCount-${index}`}
                                        onBlur={handleBlur}
                                        type="number"
                                        component={Input}
                                        value={round.matchCount}
                                        placeholder="No of matches"
                                        onChange={(e) => {
                                          onChangeRound(
                                            e.target.value,
                                            index,
                                            "matchCount",
                                            "matches"
                                          );
                                        }}
                                      />
                                      {touched?.[`matchCount-${index}`] &&
                                        errors.matchCount && (
                                          <div style={{ color: "red" }}>
                                            {errors.matchCount}
                                          </div>
                                        )}
                                    </Col>
                                    <Col lg={1} md={12} sm={24} xs={24}>
                                      <input
                                        type="checkbox"
                                        onBlur={handleBlur}
                                        id={`checkbox-${index}`}
                                        name={`hasSubMatch-${index}`}
                                        style={{
                                          width: "21px",
                                          height: "35px",
                                          marginRight: "10px",
                                        }}
                                        value={
                                          round.hasSubMatch === "true"
                                            ? true
                                            : false
                                        }
                                        checked={
                                          round.hasSubMatch === "true"
                                            ? true
                                            : false
                                        }
                                        onChange={(e) =>
                                          onCheckSubMatches(e, index)
                                        }
                                      />
                                      <label htmlFor={`checkbox-${index}`}>
                                        Does it have sub-matches?
                                      </label>
                                    </Col>
                                    {round.hasSubMatch === "true" && (
                                      <Col lg={2} md={12} sm={24} xs={24}>
                                        <Field
                                          name={`subMatchCount-${index}`}
                                          onBlur={handleBlur}
                                          type="number"
                                          component={Input}
                                          value={round.subMatchCount}
                                          placeholder="Sub Matches Count"
                                          onChange={(e) => {
                                            onChangeRound(
                                              e.target.value,
                                              index,
                                              "subMatchCount",
                                              "subMatches"
                                            );
                                          }}
                                        />
                                        {touched?.[`subMatchCount-${index}`] &&
                                          errors.subMatchCount && (
                                            <div style={{ color: "red" }}>
                                              {errors.subMatchCount}
                                            </div>
                                          )}
                                      </Col>
                                    )}
                                    <Col lg={2} md={12} sm={24} xs={24}>
                                      <Field
                                        name={`playerCount-${index}`}
                                        onBlur={handleBlur}
                                        type="number"
                                        component={Input}
                                        value={round.playerCount}
                                        placeholder="Total User Count"
                                        onChange={(e) => {
                                          onChangeRound(
                                            e.target.value,
                                            index,
                                            "playerCount"
                                          );
                                        }}
                                      />
                                      {touched?.[`playerCount-${index}`] &&
                                        errors.playerCount && (
                                          <div style={{ color: "red" }}>
                                            {errors.playerCount}
                                          </div>
                                        )}
                                    </Col>
                                    {round.hasSubMatch === "false" && (
                                      <>
                                        <Col lg={2} md={12} sm={24} xs={24}>
                                          <Field
                                            name={`roundMap-${index}`}
                                            onBlur={handleBlur}
                                            component={Input}
                                            value={round.roundMap}
                                            placeholder="Map"
                                            onChange={(e) => {
                                              onChangeRound(
                                                e.target.value,
                                                index,
                                                "roundMap"
                                              );
                                            }}
                                          />
                                          {touched?.[`roundMap-${index}`] &&
                                            errors.roundMap && (
                                              <div style={{ color: "red" }}>
                                                {errors.roundMap}
                                              </div>
                                            )}
                                        </Col>
                                        <Col lg={2} md={12} sm={24} xs={24}>
                                          <Field
                                            name={`roundPrespective-${index}`}
                                            onBlur={handleBlur}
                                            component={Input}
                                            value={round.roundPrespective}
                                            placeholder="Perspective"
                                            onChange={(e) => {
                                              onChangeRound(
                                                e.target.value,
                                                index,
                                                "roundPrespective"
                                              );
                                            }}
                                          />
                                          {touched?.[
                                            `roundPrespective-${index}`
                                          ] &&
                                            errors.roundPrespective && (
                                              <div style={{ color: "red" }}>
                                                {errors.roundPrespective}
                                              </div>
                                            )}
                                        </Col>
                                      </>
                                    )}

                                    {tournamentForEdit.tournamentRoundsAry
                                      .length >= 1 && (
                                      <Col lg={1} md={12} sm={24} xs={24}>
                                        <input
                                          type="checkbox"
                                          onBlur={handleBlur}
                                          id={`isFinalRound-${index}`}
                                          name={`isFinalRound-${index}`}
                                          style={{
                                            width: "21px",
                                            height: "35px",
                                            marginRight: "10px",
                                          }}
                                          value={
                                            round.isFinalRound === "true"
                                              ? true
                                              : false
                                          }
                                          checked={
                                            round.isFinalRound === "true"
                                              ? true
                                              : false
                                          }
                                          onChange={(e) => {
                                            if (e.target.value === "false") {
                                              rounds[index].isFinalRound =
                                                "true";
                                            } else {
                                              rounds[index].isFinalRound =
                                                "false";
                                            }
                                            setRounds([...rounds]);
                                          }}
                                        />
                                        <label
                                          htmlFor={`isFinalRound-${index}`}
                                        >
                                          Final Round
                                        </label>
                                      </Col>
                                    )}
                                    {round.contestMatches.length > 0 &&
                                      round.hasSubMatch === "false" && (
                                        <Col className="col-md-12">
                                          {" "}
                                          <h3>Contests Info</h3>
                                        </Col>
                                      )}
                                    {round.hasSubMatch === "false" &&
                                      round.contestMatches.map((match, j) => {
                                        return (
                                          <>
                                            <table
                                              className="table table-bordered w-100"
                                              key={j}
                                              style={{
                                                border: "2px solid #EBEDF3",
                                              }}
                                            >
                                              {j === 0 && (
                                                <thead>
                                                  <tr>
                                                    <th scope="col">#</th>
                                                    <th width="200" scope="col">
                                                      Date
                                                    </th>
                                                    <th width="120" scope="col">
                                                      Time Slot
                                                    </th>
                                                    <th scope="col">
                                                      User Count
                                                    </th>
                                                    <th scope="col">
                                                      Winner Count
                                                    </th>
                                                  </tr>
                                                </thead>
                                              )}
                                              <tbody>
                                                <tr key={j + 1}>
                                                  <td>
                                                    <Field
                                                      name={`R1M${j + 1}`}
                                                      value={match.matchTitle}
                                                      component={Input}
                                                      readOnly={true}
                                                    />
                                                  </td>
                                                  <td width="200">
                                                    <DatePickerField
                                                      minDate={moment(
                                                        tournamentForEdit?.startDate
                                                      ).format("YYYY-MM-DD")}
                                                      onBlur={handleBlur}
                                                      maxDate={moment(
                                                        tournamentForEdit?.endDate
                                                      )
                                                        .add(1, "days")
                                                        .format("YYYY-MM-DD")}
                                                      name={`date-${index}-${j}`}
                                                      date={match.date}
                                                      onDateSet={(date) => {
                                                        onChangeMatch(
                                                          date,
                                                          index,
                                                          j,
                                                          "date"
                                                        );
                                                      }}
                                                    />
                                                    {touched?.[
                                                      `date-${index}-${j}`
                                                    ] &&
                                                      errors.contestMatches &&
                                                      errors.contestMatches[
                                                        j
                                                      ] !== undefined && (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        >
                                                          {
                                                            errors
                                                              .contestMatches[j]
                                                              .date
                                                          }
                                                        </div>
                                                      )}
                                                  </td>
                                                  <td width="120">
                                                    <TimePickerField
                                                      maxDate={moment(
                                                        tournamentForEdit?.endDate
                                                      )}
                                                      onBlur={handleBlur}
                                                      name={`time-${index}-${j}`}
                                                      time={match.time}
                                                      onSelect={(time) => {
                                                        onChangeMatch(
                                                          time,
                                                          index,
                                                          j,
                                                          "time"
                                                        );
                                                      }}
                                                    ></TimePickerField>
                                                    {touched?.[
                                                      `time-${index}-${j}`
                                                    ] &&
                                                      errors.contestMatches &&
                                                      errors.contestMatches[
                                                        j
                                                      ] !== undefined && (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        >
                                                          {
                                                            errors
                                                              .contestMatches[j]
                                                              .time
                                                          }
                                                        </div>
                                                      )}
                                                  </td>
                                                  <td>
                                                    <Field
                                                      name={`userCount-${index}-${j}`}
                                                      onBlur={handleBlur}
                                                      placeholder="User count"
                                                      component={Input}
                                                      type="number"
                                                      onChange={(e) => {
                                                        onChangeMatch(
                                                          e.target.value,
                                                          index,
                                                          j,
                                                          "userCount"
                                                        );
                                                      }}
                                                    />
                                                    {touched?.[
                                                      `userCount-${index}-${j}`
                                                    ] &&
                                                      errors.contestMatches &&
                                                      errors.contestMatches[
                                                        j
                                                      ] !== undefined && (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        >
                                                          {
                                                            errors
                                                              .contestMatches[j]
                                                              .userCount
                                                          }
                                                        </div>
                                                      )}
                                                  </td>
                                                  <td>
                                                    <Field
                                                      name={`winnerCount-${index}-${j}`}
                                                      onBlur={handleBlur}
                                                      placeholder="Winner count"
                                                      component={Input}
                                                      type="number"
                                                      onChange={(e) => {
                                                        onChangeMatch(
                                                          e.target.value,
                                                          index,
                                                          j,
                                                          "winnerCount"
                                                        );
                                                      }}
                                                    />
                                                    {touched?.[
                                                      `winnerCount-${index}-${j}`
                                                    ] &&
                                                      errors.contestMatches &&
                                                      errors.contestMatches[
                                                        j
                                                      ] !== undefined && (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        >
                                                          {
                                                            errors
                                                              .contestMatches[j]
                                                              .winnerCount
                                                          }
                                                        </div>
                                                      )}
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </>
                                        );
                                      })}
                                    {round.hasSubMatch === "true" &&
                                      round.contestMatches.map((match, j) => {
                                        return (
                                          <>
                                            <table
                                              className="table table-bordered w-100"
                                              style={{
                                                border: "2px solid #EBEDF3",
                                              }}
                                            >
                                              <Row>
                                                <>
                                                  <Col
                                                    lg={2}
                                                    md={12}
                                                    sm={24}
                                                    xs={24}
                                                    style={{
                                                      paddingBottom: "1%",
                                                      paddingTop: "2%",
                                                      paddingLeft: "1.5%",
                                                    }}
                                                  >
                                                    {" "}
                                                    <h5>{`R1M${j + 1}`}</h5>
                                                  </Col>
                                                  <Col
                                                    lg={3}
                                                    md={12}
                                                    sm={24}
                                                    xs={24}
                                                    style={{
                                                      paddingBottom: "1%",
                                                      paddingTop: "2%",
                                                      maxWidth: "100%",
                                                    }}
                                                  >
                                                    <Field
                                                      name={`userCount-${index}-${j}`}
                                                      onBlur={handleBlur}
                                                      placeholder="User count"
                                                      component={Input}
                                                      onChange={(e) => {
                                                        onChangeMatch(
                                                          e.target.value,
                                                          index,
                                                          j,
                                                          "userCount"
                                                        );
                                                      }}
                                                      type="number"
                                                    />
                                                    {touched?.[
                                                      `userCount-${index}-${j}`
                                                    ] &&
                                                      errors.contestMatches &&
                                                      errors.contestMatches[
                                                        j
                                                      ] !== undefined && (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        >
                                                          {
                                                            errors
                                                              .contestMatches[j]
                                                              .userCount
                                                          }
                                                        </div>
                                                      )}
                                                  </Col>
                                                  <Col
                                                    lg={3}
                                                    md={12}
                                                    sm={24}
                                                    xs={24}
                                                    style={{
                                                      paddingBottom: "1%",
                                                      paddingTop: "2%",
                                                    }}
                                                  >
                                                    <Field
                                                      name={`winnerCount-${index}-${j}`}
                                                      onBlur={handleBlur}
                                                      placeholder="Winner count"
                                                      component={Input}
                                                      onChange={(e) => {
                                                        onChangeMatch(
                                                          e.target.value,
                                                          index,
                                                          j,
                                                          "winnerCount"
                                                        );
                                                      }}
                                                      type="number"
                                                    />
                                                    {touched?.[
                                                      `winnerCount-${index}-${j}`
                                                    ] &&
                                                      errors.contestMatches &&
                                                      errors.contestMatches[
                                                        j
                                                      ] !== undefined && (
                                                        <div
                                                          style={{
                                                            color: "red",
                                                          }}
                                                        >
                                                          {
                                                            errors
                                                              .contestMatches[j]
                                                              .winnerCount
                                                          }
                                                        </div>
                                                      )}
                                                  </Col>
                                                </>
                                              </Row>
                                              {match.subMatchDetails.map(
                                                (subMatch, p) => {
                                                  return (
                                                    <table
                                                      className="table table-bordered w-100"
                                                      key={p}
                                                    >
                                                      {p === 0 && (
                                                        <thead>
                                                          <tr>
                                                            <th scope="col">
                                                              #
                                                            </th>
                                                            <th
                                                              width="200"
                                                              scope="col"
                                                            >
                                                              Date
                                                            </th>
                                                            <th
                                                              width="120"
                                                              scope="col"
                                                            >
                                                              Time Slot
                                                            </th>
                                                            <th scope="col">
                                                              Map
                                                            </th>
                                                            <th scope="col">
                                                              Perspective
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                      )}
                                                      <tbody>
                                                        <tr key={j + 1}>
                                                          <td>
                                                            <Field
                                                              required
                                                              name={`matchTitle-${j}-${p}`}
                                                              value={
                                                                subMatch.matchTitle
                                                              }
                                                              component={Input}
                                                              readOnly={true}
                                                            />
                                                          </td>
                                                          <td width="200">
                                                            <DatePickerField
                                                              onBlur={
                                                                handleBlur
                                                              }
                                                              minDate={moment(
                                                                tournamentForEdit?.startDate
                                                              ).format(
                                                                "YYYY-MM-DD"
                                                              )}
                                                              maxDate={moment(
                                                                tournamentForEdit?.endDate
                                                              )
                                                                .add(1, "days")
                                                                .format(
                                                                  "YYYY-MM-DD"
                                                                )}
                                                              required
                                                              name={`date-${j}-${p}`}
                                                              date={
                                                                subMatch.date
                                                              }
                                                              onDateSet={(
                                                                date
                                                              ) => {
                                                                onChangeSubMatch(
                                                                  date,
                                                                  index,
                                                                  j,
                                                                  p,
                                                                  "date"
                                                                );
                                                              }}
                                                            />
                                                            {touched?.[
                                                              `date-${j}-${p}`
                                                            ] &&
                                                              errors.contestMatches &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ] !== undefined &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ]
                                                                .subMatchDetails &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ].subMatchDetails[
                                                                p
                                                              ] !==
                                                                undefined && (
                                                                <div
                                                                  style={{
                                                                    color:
                                                                      "red",
                                                                  }}
                                                                >
                                                                  {
                                                                    errors
                                                                      .contestMatches[
                                                                      j
                                                                    ]
                                                                      .subMatchDetails[
                                                                      p
                                                                    ].date
                                                                  }
                                                                </div>
                                                              )}
                                                          </td>
                                                          <td width="120">
                                                            <TimePickerField
                                                              maxDate={moment(
                                                                tournamentForEdit?.endDate
                                                              )}
                                                              onBlur={
                                                                handleBlur
                                                              }
                                                              name={`time-${j}-${p}`}
                                                              time={
                                                                subMatch.time
                                                              }
                                                              onSelect={(
                                                                time
                                                              ) => {
                                                                onChangeSubMatch(
                                                                  time,
                                                                  index,
                                                                  j,
                                                                  p,
                                                                  "time"
                                                                );
                                                              }}
                                                            ></TimePickerField>
                                                            {touched?.[
                                                              `time-${j}-${p}`
                                                            ] &&
                                                              errors.contestMatches &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ] !== undefined &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ]
                                                                .subMatchDetails &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ].subMatchDetails[
                                                                p
                                                              ] !==
                                                                undefined && (
                                                                <div
                                                                  style={{
                                                                    color:
                                                                      "red",
                                                                  }}
                                                                >
                                                                  {
                                                                    errors
                                                                      .contestMatches[
                                                                      j
                                                                    ]
                                                                      .subMatchDetails[
                                                                      p
                                                                    ].time
                                                                  }
                                                                </div>
                                                              )}
                                                          </td>
                                                          <td>
                                                            <Field
                                                              name={`map-${j}-${p}`}
                                                              onBlur={
                                                                handleBlur
                                                              }
                                                              value={
                                                                subMatch.map
                                                              }
                                                              component={Input}
                                                              type="text"
                                                              onChange={(e) => {
                                                                onChangeSubMatch(
                                                                  e.target
                                                                    .value,
                                                                  index,
                                                                  j,
                                                                  p,
                                                                  "map"
                                                                );
                                                              }}
                                                            />
                                                            {touched?.[
                                                              `map-${j}-${p}`
                                                            ] &&
                                                              errors.contestMatches &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ] !== undefined &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ]
                                                                .subMatchDetails &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ].subMatchDetails[
                                                                p
                                                              ] !==
                                                                undefined && (
                                                                <div
                                                                  style={{
                                                                    color:
                                                                      "red",
                                                                  }}
                                                                >
                                                                  {
                                                                    errors
                                                                      .contestMatches[
                                                                      j
                                                                    ]
                                                                      .subMatchDetails[
                                                                      p
                                                                    ].map
                                                                  }
                                                                </div>
                                                              )}
                                                          </td>
                                                          <td>
                                                            <Field
                                                              name={`prespective-${j}-${p}`}
                                                              onBlur={
                                                                handleBlur
                                                              }
                                                              value={
                                                                subMatch.prespective
                                                              }
                                                              component={Input}
                                                              type="text"
                                                              onChange={(e) => {
                                                                onChangeSubMatch(
                                                                  e.target
                                                                    .value,
                                                                  index,
                                                                  j,
                                                                  p,
                                                                  "prespective"
                                                                );
                                                              }}
                                                            />
                                                            {touched?.[
                                                              `prespective-${j}-${p}`
                                                            ] &&
                                                              errors.contestMatches &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ] !== undefined &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ]
                                                                .subMatchDetails &&
                                                              errors
                                                                .contestMatches[
                                                                j
                                                              ].subMatchDetails[
                                                                p
                                                              ] !==
                                                                undefined && (
                                                                <div
                                                                  style={{
                                                                    color:
                                                                      "red",
                                                                  }}
                                                                >
                                                                  {
                                                                    errors
                                                                      .contestMatches[
                                                                      j
                                                                    ]
                                                                      .subMatchDetails[
                                                                      p
                                                                    ]
                                                                      .prespective
                                                                  }
                                                                </div>
                                                              )}
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  );
                                                }
                                              )}
                                            </table>
                                          </>
                                        );
                                      })}
                                  </Row>
                                </CardBody>
                                <div className="col-12">
                                  <div className="col-md-12">
                                    <button
                                      type="submit"
                                      className="btn btn-primary m-5 float-right"
                                      title="Add Round"
                                    >
                                      Submit Round
                                    </button>
                                  </div>
                                  {/* )} */}
                                </div>
                              </Card>
                            );
                          })
                        }
                      />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        )}
      </Row>

      <Row>
        <Col className="mb-4 col-md-12">
          {tournamentForEdit &&
            tournamentForEdit?.tournamentRoundsAry &&
            tournamentForEdit.tournamentRoundsAry.map((round, index) => (
              <Card key={"round" + index} className="text-capitalize">
                <CardHeader
                  title={
                    round?.isFinalRound && round.isFinalRound === true
                      ? `${round.title} (FINAL ROUND)`
                      : round.title
                  }
                >
                  <Button
                    onClick={() => {
                      deleteMatchRound(round);
                    }}
                    className="btn-sm  h-40px w-120px btn mt-5 text-uppercase btn-danger"
                  >
                    Delete
                  </Button>
                </CardHeader>
                {round.hasSubMatch ? (
                  <CardBody>
                    <Accordion defaultActiveKey={0} flash>
                      {round.tournamentMatchDetailsInfo
                        .filter((a) => a.matchId === undefined)
                        .map((match, matchIndex) => (
                          <Card style={{ margin: "17px 0px 0px 0px" }}>
                            <Accordion.Toggle
                              eventKey={matchIndex}
                              as={Button}
                              variant="link"
                            >
                              <Row style={{ padding: "10px" }}>
                                <Col lg={4} md={12} sm={24} xs={24}>
                                  <b>Match Title :: {match.matchTitle}</b>
                                </Col>
                                <Col lg={4} md={12} sm={24} xs={24}>
                                  <b>Total User Count :: {match.userCount}</b>
                                </Col>
                                <Col lg={4} md={12} sm={24} xs={24}>
                                  <b>
                                    Total Winner Count :: {match.winnerCount}
                                  </b>
                                </Col>
                              </Row>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey={matchIndex}>
                              <table className="table table-bordered table-striped font-12em">
                                {renderHeader(true)}
                                <tbody>
                                  {round.tournamentMatchDetailsInfo
                                    .filter((b) => b.matchId === match._id)
                                    .map((submatch, ind) => (
                                      <tr key={"match" + submatch._id}>
                                        <td>{submatch.matchTitle}</td>
                                        <td>
                                          {moment(submatch.matchDate).format(
                                            "DD, MMM YYYY"
                                          )}
                                        </td>
                                        <td>
                                          {moment(submatch.matchTime).format(
                                            "hh:mm A"
                                          )}
                                        </td>
                                        <td>
                                          {submatch.rpUploadTime != null
                                            ? moment(
                                                submatch.rpUploadTime
                                              ).format("lll")
                                            : "-"}
                                        </td>
                                        <td>
                                          {submatch.ssUploadTime != null
                                            ? moment(
                                                submatch.ssUploadTime
                                              ).format("lll")
                                            : "-"}
                                        </td>
                                        <td>{submatch.status}</td>
                                        <td>{submatch.roundMap}</td>
                                        <td>{submatch.roundPrespective}</td>
                                        <td>
                                          <Link
                                            to={"#"}
                                            onClick={() =>
                                              viewContest(submatch._id)
                                            }
                                            className="btn w-60px btn-sm btn-primary font-weight-bolder text-uppercase"
                                          >
                                            View
                                          </Link>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </Accordion.Collapse>
                          </Card>
                        ))}
                    </Accordion>
                  </CardBody>
                ) : (
                  <CardBody>
                    <table className="table table-bordered table-striped font-12em">
                      {renderHeader(false)}
                      {console.log(round)}
                      <tbody>
                        {round.tournamentMatchDetailsInfo.map((match, ind) => (
                          <tr key={"match" + ind}>
                            <td>{match.matchTitle}</td>
                            <td>
                              {moment(match.matchDate).format("DD, MMM YYYY")}
                            </td>
                            <td>{moment(match.matchTime).format("hh:mm A")}</td>
                            <td>
                              {match.rpUploadTime != null
                                ? moment(match.rpUploadTime).format("lll")
                                : "-"}
                            </td>
                            <td>
                              {match.ssUploadTime != null
                                ? moment(match.ssUploadTime).format("lll")
                                : "-"}
                            </td>
                            <td>{match.status}</td>
                            <td>{match.userCount}</td>
                            <td>{match.winnerCount}</td>
                            <td>{round.roundMap}</td>
                            <td>{round.roundPrespective}</td>
                            <td>
                              <Link
                                to={"#"}
                                onClick={() => viewContest(match._id)}
                                className="btn w-60px btn-sm btn-primary font-weight-bolder text-uppercase"
                              >
                                View
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </CardBody>
                )}
              </Card>
            ))}
        </Col>
      </Row>
    </>
  );
};
export default TournamentView;
